export const VISIT_STATUS = {
  checked_in: 'Checked In',
  scheduled: 'Scheduled',
  bill_submitted: 'Bill submitted',
  completed: 'Completed',
  available: 'Available',
  last: 'Last',
  admit: 'Admit',
  not_seen: 'Not seen',
  super_bill: 'Superbill',
  bill_rejected: 'Bill rejected',
  claim_assigned: 'Claim assigned',
}

export const BUTTON_STATUS = {
  discharge: 'Discharge',
  billSalt: 'Bill SALT',
  confirm: 'Confirm',
  undo_discharge: 'Undo discharge',
  skip: 'Skip',
  recall: 'Recall bill',
  undo_skip: 'Undo skip',
  bill: 'Bill',
  void: 'Void',
  download_note: 'Download Notes',
  cosign: 'CO-SIGN',
}

export const STATUS_GROUPS = {
  in_complete: 'Incomplete',
  completed: 'Completed',
  available: 'Available',
}
